import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';

const TribunMultipleEventCheckModal = props => {

  /*const buttonConfig = {
    primary: {
      label: 'OYNA',
      onClick: props.onPrimaryButtonClick
    },
    secondary: {
      label: 'VAZGEÇ',
      onClick: props.onSecondaryButtonClick
    }
  };*/

  const successMessage = 'Oynamak istediğin kuponda başlayan veya bahse kapanan bazı maçlar var. Lütfen oynamadan önce kuponunu kontrol et.';

  return (
    <Message type="none">
      <p dangerouslySetInnerHTML={ { __html: successMessage } } />
    </Message>
  );
};

TribunMultipleEventCheckModal.propTypes = {
  balance: PropTypes.number
};

export default TribunMultipleEventCheckModal;
